import { useEffect } from 'react';
export const useOutsideClick = (refs, outsideClick) => {
    useEffect(() => {
        const handleOutsideClick = (event) => {
            const isOutsideClick = refs.every((ref) => ref.current && !ref.current.contains(event.target));
            if (isOutsideClick) {
                outsideClick();
            }
        };
        const dialogEl = document.querySelector('dialog');
        document.addEventListener('mousedown', handleOutsideClick);
        dialogEl?.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            dialogEl?.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [outsideClick, refs]);
};
//# sourceMappingURL=use-outside-click.js.map